// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#login-card[data-v-425754f0] {\n  margin-top: -50px;\n}\n.sso-login[data-v-425754f0] {\n  /* margin-top: 0.55rem; */\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n", ""]);
// Exports
module.exports = exports;
